import { registerComponent, handleize } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-brand",
  class PredictiveSearchResultBrand extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.result);
      this.link = this.querySelector("a");

      this.setText();
      this.setHref();
    }

    get href() {
      return `${WYATT.routes.root}collections/${handleize(this.data.value)}`;
    }

    setText() {
      this.link.innerHTML = this.data.label;
    }

    setHref() {
      this.link.href = this.href;
    }
  },
);
